import { EditDefaultPricingRuleDialog } from '@src/containers/Dealer/CustomerPricing/EditDefaultPricingRuleDialog';
import { CustomerAllInTiers } from '@src/containers/Dealer/CustomerPricingTiers/CustomerAllInTiers';
import {
  CustomerPricingTiersLoad,
  useCustomerPricingTiersShared,
} from '@src/containers/Dealer/CustomerPricingTiers/useCustomerPricingTiersShared';
import { CUSTOMER_ALL_IN_TIERS_STANDALONE_PERSIST_KEY } from '@src/containers/Dealer/CustomerPricingTiers/utils';
import type { CustomerAllInTiersPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAllInTiersPanel({ api, params }: LayoutPanelProps<CustomerAllInTiersPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-all-in-tiers-panel"
    >
      <CustomerAllInTiersPanelContent />
    </EntityAdminPanelShell>
  );
}

function CustomerAllInTiersPanelContent() {
  const shared = useCustomerPricingTiersShared(CustomerPricingTiersLoad.AllIn);
  return (
    <>
      <EditDefaultPricingRuleDialog
        {...shared.defaultPricingRuleDialog}
        handleEditPricingRule={shared.handleEditPricingRule}
      />
      <CustomerAllInTiers shared={shared} persistKey={CUSTOMER_ALL_IN_TIERS_STANDALONE_PERSIST_KEY} />
    </>
  );
}
